module.exports = __webpack_public_path__ + "img/img4.a0736179.png";